<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card-title>Commission Tiers</v-card-title>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6" lg="4" xl="3">
        <v-btn block outlined color="primary" @click="addCommissionTier">
          {{ commissionTiers && commissionTiers.length > 0 ? 'ADD TIER' : 'ADD DEFAULT TIERS' }}
          <v-icon right>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <CommissionTiersTable
          class="px-3"
          :commissionTiers="commissionTiersValue"
          :showEditButtons="isAdmin"
          @editTier="showEditTierModal"
          @deleteTier="showDeleteTierDialog"
        ></CommissionTiersTable>
      </v-col>
    </v-row>
    <CommissionTierEditModal
      ref="CommissionTierEditModal"
      @editTier="editTier"
    ></CommissionTierEditModal>
    <ConfirmationModal
      :contentText="'Are you sure you want to delete the selected tier?'"
      :showModal="showDeleteTierDialogProp"
      :title="'Delete Confirmation'"
      :toolbarColor="'primary'"
      @cancel-click="() => { this.showDeleteTierDialogProp = false; this.tierIdToDelete = null }"
      @ok-click="deleteTier"
    ></ConfirmationModal>
  </div>
</template>

<script>
import CommissionTiersTable from '@/components/commissionTiers/CommissionTiersTable'
import CommissionTierEditModal from '@/components/commissionTiers/CommissionTierEditModal'
import { COMMISSION_TIERS_USER } from '@/lib/constants/commissions'
import guid from '@/lib/guid'
import { userIsAdmin } from '@/lib/authentication'
import { ConfirmationModal } from '@/components/dialogs'

export default {
  components: {
    CommissionTiersTable,
    CommissionTierEditModal,
    ConfirmationModal
  },
  props: [
    'commissionTiers'
  ],
  data () {
    return {
      tierIdToDelete: null,
      showDeleteTierDialogProp: false
    }
  },
  computed: {
    commissionTiersValue: {
      get () {
        return this.commissionTiers
      },
      set (newValue) {
        this.$emit('commissionTiersChange', newValue)
      }
    },
    isAdmin () {
      return userIsAdmin()
    }
  },
  methods: {
    addCommissionTier () {
      if (!this.commissionTiersValue || this.commissionTiersValue.length === 0) {
        this.commissionTiersValue = COMMISSION_TIERS_USER.map(c => {
          return Object.assign({}, c, { id: guid(), userId: this.id })
        })
      } else {
        let newTier = {
          id: guid(),
          userId: this.userId,
          commissionPercent: null,
          maxAmount: null,
          minAmount: null
        }
        this.commissionTiersValue = [...this.commissionTiers, newTier]
      }
    },
    showEditTierModal (item) {
      this.$refs.CommissionTierEditModal.showModal(item)
    },
    editTier (tier) {
      let index = this.commissionTiersValue.findIndex(item => item.id === tier.id)
      this.commissionTiersValue.splice(index, 1, tier)
    },
    showDeleteTierDialog (item) {
      this.tierIdToDelete = item.id
      this.showDeleteTierDialogProp = true
    },
    deleteTier () {
      let indexToDelete = this.commissionTiersValue.findIndex(item => item.id === this.tierIdToDelete)
      this.commissionTiersValue.splice(indexToDelete, 1)
      this.showDeleteTierDialogProp = false
    }
  }
}
</script>
